import cloneDeep from 'lodash/cloneDeep'

const hasArrayChild = (obj, childrenKey) => {
  return obj[childrenKey] && Array.isArray(obj[childrenKey])
}

export default class FileTreeData {
  constructor({
    data,
    childrenKey,
    checkedValues = [],
    collectNum = 0,
    selectChildren = true, // 是否选则children
  }) {
    const _deepData = cloneDeep(data)
    this.data = _deepData
    this.childrenKey = childrenKey
    this.checkedValues = checkedValues
    this.selectChildren = selectChildren
    this.collectNum = collectNum
    this.recursiveOpt(this.data, null)
    this.checkAllMarkStatus()
  }

  checkMoveAllMarkStatus(nodeId) {
    const loop = (tree) => {
      tree.forEach((node) => {
        node.checked = false
        node.indeterminate = false
        if (node.value === nodeId) {
          node.checked = true
          this.checkSelectMarkStatus(node)
        }
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    loop(this.data)
  }

  checkAllMarkStatus() {
    const loop = (tree) => {
      tree.forEach((node) => {
        if (this.checkedValues.includes(node.value)) {
          node.checked = true
        }
        this.checkSelectMarkStatus(node)
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    loop(this.data)
  }

  checkSelectMarkStatus(node) {
    const loop = (chidNode) => {
      chidNode.forEach(child => {
        if (child.checked) {
          node.indeterminate = true
        } else {
          node.indeterminate = false
        }
        if (chidNode[this.childrenKey]) {
          loop(chidNode[this.childrenKey])
        }
      })
    }
    const loopParent = (parentNode) => {
      if (node.checked && parentNode) {
        parentNode.indeterminate = true
      } else {
        node.indeterminate = false
      }
      if (parentNode.parent) {
        loopParent(parentNode.parent)
      }
    }

    if (node && node.parent && this.selectChildren) {
      loopParent(node.parent)
    }
    if (node && hasArrayChild(node, this.childrenKey) && this.selectChildren) {
      loop(node[this.childrenKey])
    }
  }

  checkNoSelectMarkStatus(node) {
    let flag = false
    const loop = (childNode) => {
      childNode.forEach(child => {
        if (child.checked) {
          flag = true
        }
        if (child[this.childrenKey]) {
          loop(child[this.childrenKey])
        }
      })
    }

    const loopParent = (parentNode) => {
      if (!node.checked && parentNode) {
        parentNode.indeterminate = false
      }
      if (parentNode.parent && !parentNode.checked) {
        loopParent(parentNode.parent)
      }
    }

    if (node && hasArrayChild(node, this.childrenKey) && this.selectChildren) {
      loop(node[this.childrenKey])
    }
    if (node && node.parent && this.selectChildren) {
      if (!flag) {
        loopParent(node.parent)
      }
    }
  }

  controlQuantity(checked, curItem) {
    const root = this.getRootByValue(curItem.value) || curItem
    if (checked) {
      root.collectNum += 1
    } else {
      root.collectNum -= 1
    }
    if ((this.collectNum + root.collectNum) > root.blogNumLimit) {
      root.disabled = true
    } else {
      root.disabled = false
    }
    const loop = (tree) => {
      tree.forEach((node) => {
        if ((this.collectNum + root.collectNum) > root.blogNumLimit) {
          node.disabled = true
        } else {
          node.disabled = false
        }
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    if (hasArrayChild(root, this.childrenKey)) {
      loop(root[this.childrenKey])
    }
  }

  /**
    * 递归option数据
    * 标记数据树形层级 parent
    * 打上初始状态 checked indeterminate
    */
  recursiveOpt(nodeArr, parent, level = 0, collectNum = 0) {
    level += 1
    nodeArr.forEach((node) => {
      node.parent = parent
      node.label = node.name
      node.value = node.id
      node.indeterminate = false // 半选
      node.checked = false // 选中
      node.level = level
      if (node.currentCollectFlag) {
        node.checked = true
      }
      if (node.level === 1) {
        node.collectNum = node.blogNum
        collectNum = node.blogNumLimit
      } else {
        node.collectNum = collectNum
      }

      this.controlQuantity(node.checked, node)

      if (hasArrayChild(node, this.childrenKey)) {
        this.recursiveOpt(node[this.childrenKey], node, level, collectNum)
      }
    })
  }

  someIsChild(toValue, fromValue) {
    if (toValue === fromValue) { // 相同的则为false
      return false
    }
    let flag = false
    const currentNode = this.findNodeByValue(fromValue)
    const loop = (nodeArr) => {
      nodeArr.forEach((node) => {
        if (node.value === toValue) {
          flag = true
          return
        }
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    if (currentNode.child.length) {
      loop(currentNode.child)
    }
    return flag
  }

  findNodeByValue(value) {
    if (!value) {
      console.error('必填参数')
      return
    }
    const result = {
      parent: null,
      brother: [],
      current: null,
      child: [],
    }
    const loop = (tree) => {
      tree.forEach((node) => {
        if (node.value == value) {
          result.current = node
          result.brother = tree
          if (node[this.childrenKey]?.length) {
            result.child = node[this.childrenKey]
          }
          if (node.parent) {
            result.parent = node.parent
          }
        }
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    loop(this.data)
    return result
  }

  searchAllNode(text) {
    const result = {
      parent: [],
      allChild: [],
    }
    const loop = (tree) => {
      tree.forEach((node) => {
        if (node.label.indexOf(text) !== -1) {
          if (node.level === 1) {
            result.parent.push(node)
          } else {
            result.allChild.push(node)
          }
        }
        if (hasArrayChild(node, this.childrenKey)) {
          loop(node[this.childrenKey])
        }
      })
    }
    loop(this.data)
    return result
  }

  getRootByValue(value) {
    if (!value) return null
    let root = this.findNodeByValue(value)
    while (root?.parent) {
      root = root.parent
    }
    return root.current || root
  }
}
